/**
 * The kit's checkbox in plain DOM (UI r1 deliverable 5), for vanilla views
 * such as the editor's to-do items. With a label it is `Checkbox`'s tree; the
 * bare form (`cx-checkbox--bare`) holds only the input and the box, a 24 px
 * target whose input carries the accessible name.
 */
import { iconSvg } from '../icon/dom.js';
export const checkboxClass = {
    root: 'cx-checkbox',
    bare: 'cx-checkbox--bare',
    input: 'cx-checkbox__input',
    box: 'cx-checkbox__box',
    disabled: 'cx-checkbox--disabled',
    label: 'cx-checkbox__label',
    description: 'cx-checkbox__description',
};
export function checkboxDom(options) {
    const { checked, label, ariaLabel, bare = false, disabled = false } = options;
    const name = ariaLabel ?? (bare ? label : undefined);
    if (!label && !ariaLabel)
        throw new Error('checkboxDom: give a label or an ariaLabel');
    const root = document.createElement('label');
    root.className = [
        checkboxClass.root,
        bare && checkboxClass.bare,
        disabled && checkboxClass.disabled,
    ]
        .filter(Boolean)
        .join(' ');
    const input = document.createElement('input');
    input.type = 'checkbox';
    input.className = checkboxClass.input;
    input.defaultChecked = checked;
    input.checked = checked;
    input.disabled = disabled;
    if (name)
        input.setAttribute('aria-label', name);
    const box = document.createElement('span');
    box.className = checkboxClass.box;
    box.setAttribute('data-control-boundary', '');
    box.setAttribute('aria-hidden', 'true');
    box.appendChild(iconSvg('check', { size: 12, weight: 'fill' }));
    root.append(input, box);
    if (!bare && label) {
        const text = document.createElement('span');
        text.className = checkboxClass.label;
        text.textContent = label;
        root.appendChild(text);
    }
    return { root, input };
}
//# sourceMappingURL=checkbox-dom.js.map